export enum CompositeAnswerPortion {
    None = 0,
    Row = 1,
    Column = 2
}
